
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_fzqam_94",
  "pad-bottom": "awsui_pad-bottom_15o6u_fzqam_114",
  "has-background": "awsui_has-background_15o6u_fzqam_123",
  "highlighted": "awsui_highlighted_15o6u_fzqam_126",
  "selected": "awsui_selected_15o6u_fzqam_126",
  "disabled": "awsui_disabled_15o6u_fzqam_140",
  "next-item-selected": "awsui_next-item-selected_15o6u_fzqam_148",
  "is-keyboard": "awsui_is-keyboard_15o6u_fzqam_156",
  "parent": "awsui_parent_15o6u_fzqam_160",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_fzqam_164",
  "child": "awsui_child_15o6u_fzqam_176",
  "virtual": "awsui_virtual_15o6u_fzqam_191",
  "measure-strut": "awsui_measure-strut_15o6u_fzqam_202",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_fzqam_211",
  "screenreader-content": "awsui_screenreader-content_15o6u_fzqam_215",
  "option-content": "awsui_option-content_15o6u_fzqam_221"
};
  